import {ChevronRightIcon, MinusIcon, PlusIcon} from '@heroicons/react/solid';
import {useState} from 'react';

import {Badge, Button, Table, TBody, Td, Th, Thead, Tr} from '@/components';
import type {AdminAfriexReward} from '@/types';
import {statusColors} from '@/types/Transaction';
import {formatValues} from '@/utils/dashboard';

import RewardSummary from './RewardSummary';

const RewardsTable = ({items}: {items: AdminAfriexReward[]}) => {
  return (
    <Table className="overflow-hidden">
      <Thead>
        <Tr enableHover={false}>
          <Th>&nbsp;</Th>
          <Th>Name</Th>
          <Th>Description</Th>
          <Th>Status</Th>
          <Th>Points</Th>
          <Th>&nbsp;</Th>
        </Tr>
      </Thead>
      <TBody>
        {items.map((item, index) => (
          <TRow item={item} key={index} index={index} />
        ))}
      </TBody>
    </Table>
  );
};

const TRow = ({item, index}: {item: AdminAfriexReward; index: number}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const status = item?.isDeactivated ? 'Inactive' : 'Active';
  const statusColor =
    statusColors[item?.isDeactivated ? 'processing' : 'successful'];
  const zebraRow = index % 2 === 0 ? '' : 'bg-gray-50 dark:bg-dark-zebraRow';

  return (
    <>
      <Tr className={zebraRow}>
        <Td isNumeric className="px-3">
          <Button onClick={() => setIsExpanded(!isExpanded)} variant="unStyled">
            <div
              className={`border-2 border-gray-700 dark:border-dark-borderLight dark:text-gray-200 text-gray-700 w-5 h-5 flex justify-center rounded hover:bg-cyan-50 ${
                isExpanded && 'bg-cyan-50'
              }`}
            >
              {isExpanded ? (
                <MinusIcon className="w-4 h-4" />
              ) : (
                <PlusIcon className="w-4 h-4" />
              )}
            </div>
          </Button>
        </Td>
        <Td className={'font-medium'}>{item?.name}</Td>
        <Td>
          <div className="break-words">{item?.description}</div>
        </Td>
        <Td>
          <Badge label={status} colorScheme={statusColor} />
        </Td>
        <Td>{formatValues(item.pointsValue, 'money')}</Td>
        <Td>
          <div
            className="w-5 h-5 flex justify-center text-gray-700 dark:text-gray-300 hover:border rounded-lg hover:border-gray-300 hover:bg-cyan-50 hover:text-cyan-500"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <ChevronRightIcon className="w-5 h-5" />
          </div>
        </Td>
      </Tr>

      {isExpanded && (
        <Tr enableHover={false}>
          <Td colSpan={9} className="p-0 m-0">
            <div className="flex py-10 px-8 justify-center bg-sky-50 dark:bg-transparent w-full">
              <RewardSummary data={item} />
            </div>
          </Td>
        </Tr>
      )}
    </>
  );
};

export default RewardsTable;
